import { Layout } from '@/components/layout/Layout';
import { SEOHead } from '@/components/SEOHead';
import { Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface ComingSoonPageProps {
  title: string;
  description: string;
  canonical: string;
  tagline?: string;
}

export function ComingSoonPage({ title, description, canonical, tagline }: ComingSoonPageProps) {
  return (
    <Layout>
      <SEOHead title={`${title} — Ethio Real Estates`} description={description} canonical={canonical} />
      <section className="container py-20 min-h-[60vh] flex flex-col items-center justify-center text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold uppercase tracking-wider mb-6">
          <Sparkles className="h-3.5 w-3.5" /> Coming Soon
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">{title}</h1>
        <p className="text-muted-foreground max-w-xl mb-8">{tagline || description}</p>
        <Button asChild>
          <Link to="/">Back to Home</Link>
        </Button>
      </section>
    </Layout>
  );
}

export default ComingSoonPage;
